// Mock data for HBM Survey Projects website

export const contactInfo = {
  phone: '0795254796',
  email: 'bernard@hbmsurveys.co.za',
  address: '55 African Mourning Dove Crescent, The Hills Game Reserve',
  location: { lat: -29.7833, lng: 30.8333 } // KwaZulu-Natal coordinates
};

export const stats = [
  { id: 'experience', number: '10+', label: 'Years Experience' },
  { id: 'value', number: 'R5M+', label: 'Project Value Delivered' },
  { id: 'surveys', number: '100+', label: 'Surveys Completed' },
  { id: 'trusted', number: '100%', label: 'Trusted by Construction Professionals' }
];

export const services = [
  {
    id: 1,
    title: 'Site Supervision',
    description: 'Professional on-site monitoring and quality control to ensure construction projects meet exact specifications and standards.',
    icon: 'ClipboardCheck'
  },
  {
    id: 2,
    title: 'Topographical Surveys',
    description: 'Detailed terrain mapping and elevation data for engineering design and construction planning.',
    icon: 'Mountain'
  },
  {
    id: 3,
    title: 'Construction Layout Surveys',
    description: 'Accurate site layout and positioning services ensuring construction projects meet exact specifications.',
    icon: 'Ruler'
  },
  {
    id: 4,
    title: 'Aerial LiDAR Surveys',
    description: 'Advanced aerial laser scanning for large-scale topographic mapping and 3D terrain modeling.',
    icon: 'Plane'
  },
  {
    id: 5,
    title: 'Engineering Surveys',
    description: 'Precise measurements and data collection for engineering design, construction, and infrastructure projects.',
    icon: 'HardHat'
  },
  {
    id: 6,
    title: '3D Scanning',
    description: 'High-precision 3D laser scanning for as-built documentation, BIM modeling, and digital twins.',
    icon: 'Scan'
  },
  {
    id: 7,
    title: 'Underground Utility Service Detection',
    description: 'Non-destructive underground utility detection and mapping to prevent damage during excavation.',
    icon: 'Cable'
  }
];

export const processSteps = [
  {
    step: 1,
    title: 'Project Consultation',
    description: 'We discuss the project requirements, location, and type of survey needed.',
    icon: 'MessageSquare'
  },
  {
    step: 2,
    title: 'Site Survey & Data Collection',
    description: 'Our surveyors visit the site and collect accurate measurements using professional surveying equipment.',
    icon: 'MapPinned'
  },
  {
    step: 3,
    title: 'Data Processing & Analysis',
    description: 'Survey data is processed using modern surveying software to ensure precise results.',
    icon: 'LineChart'
  },
  {
    step: 4,
    title: 'Final Survey Report',
    description: 'Clients receive detailed survey documentation that can be used for construction and development planning.',
    icon: 'FileText'
  }
];

export const projects = [
  {
    id: 1,
    title: 'Commercial Building Construction Survey',
    description: 'Precision layout and topographical survey for multi-story commercial development',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/8x9gfrpa_a26c4340-179f-4eb9-93c6-0d85462c4891.jpeg'
  },
  {
    id: 2,
    title: 'Mine Infrastructure Development',
    description: 'Comprehensive surveying for mine infrastructure construction and development',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/q8coq300_0369609c-2548-4c73-8492-fa89eb962aea.jpeg'
  },
  {
    id: 3,
    title: 'Road Construction Layout Survey',
    description: 'Site preparation and layout surveys for major road development',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/nw0g58n5_05e0871d-936b-49d2-a258-3b2a5b9682d1.jpeg'
  },
  {
    id: 4,
    title: 'Control Network',
    description: 'Establishment of precise control networks for large-scale surveying and mapping projects',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/g6to30us_WhatsApp%20Image%202026-03-24%20at%2018.59.01.jpeg'
  },
  {
    id: 5,
    title: 'Hydrographic Survey',
    description: 'Underwater terrain mapping and bathymetric surveys for marine and coastal projects',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/whowyr2l_63014c56-efcf-4ceb-b732-e24de0e21c28.jpeg'
  },
  {
    id: 6,
    title: 'Solar Farm Layout',
    description: 'Precision surveying and site layout for large-scale solar energy installations',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/y4zdsasn_afa9bdb9-1ecc-421d-ae49-e6ae383dcfbe.jpeg'
  },
  {
    id: 7,
    title: 'Bulk Earthwork',
    description: 'Volumetric surveys and earthwork calculations for construction and mining projects',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/koiyaabp_WhatsApp%20Image%202026-04-07%20at%2015.24.41.jpeg'
  },
  {
    id: 8,
    title: 'Aerial LiDAR Surveys',
    description: 'Advanced drone-based LiDAR mapping for topographic data and 3D terrain modeling',
    image: 'https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/zzbbn64g_6a6c8fe6-cba1-4f69-a151-4ff22e107fb7.jpeg'
  }
];

export const equipment = [
  {
    id: 1,
    name: 'GPS Surveying Equipment',
    description: 'High-precision GPS technology for accurate positioning and measurements',
    icon: 'Satellite'
  },
  {
    id: 2,
    name: 'Total Station Instruments',
    description: 'Advanced total stations for comprehensive angular and distance measurements',
    icon: 'Compass'
  },
  {
    id: 3,
    name: '3D Terrestrial Scanner',
    description: 'State-of-the-art 3D laser scanning for millimeter-accurate as-built documentation',
    icon: 'Scan'
  },
  {
    id: 4,
    name: 'Ground Penetration Radar Equipment',
    description: 'Advanced GPR technology for underground utility detection and subsurface investigation',
    icon: 'Radio'
  },
  {
    id: 5,
    name: 'DJI M400 LiDAR Equipped Drones',
    description: 'Professional drone-mounted LiDAR systems for aerial surveying and mapping',
    icon: 'Plane'
  },
  {
    id: 6,
    name: 'Data Processing Software',
    description: 'Industry-leading software for processing and analyzing survey data with precision',
    icon: 'Monitor'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'High Precision Equipment',
    description: 'State-of-the-art surveying technology for maximum accuracy',
    icon: 'Crosshair'
  },
  {
    id: 2,
    title: 'Experienced Professionals',
    description: 'Skilled surveyors with extensive industry experience',
    icon: 'Users'
  },
  {
    id: 3,
    title: 'Reliable Measurements',
    description: 'Consistent, accurate data you can depend on',
    icon: 'CheckCircle'
  },
  {
    id: 4,
    title: 'Trusted by Industry',
    description: 'Preferred by contractors, developers, and engineers',
    icon: 'Award'
  },
  {
    id: 5,
    title: 'Efficient Turnaround',
    description: 'Quick project completion without compromising quality',
    icon: 'Clock'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'David Makwela',
    position: 'Project Manager, Umhlanga Developments',
    content: 'HBM Survey Projects delivered accurate and reliable survey data for our development project. Their professionalism and attention to detail made the process smooth and efficient.',
    image: 'https://images.unsplash.com/photo-1758520145178-29eafeda9908?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHMlMjBvZmZpY2V8ZW58MHx8fHwxNzczNjg1OTEyfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    name: 'Sarah Naidoo',
    position: 'Civil Engineer, Coastal Engineering Solutions',
    content: 'We have worked with HBM on multiple projects. Their surveying accuracy and fast turnaround times have been instrumental in keeping our construction projects on schedule.',
    image: 'https://images.unsplash.com/photo-1758518727077-ffb66ffccced?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHMlMjBvZmZpY2V8ZW58MHx8fHwxNzczNjg1OTEyfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    name: 'Michael van der Merwe',
    position: 'Property Developer, Hillcrest Properties',
    content: 'Professional service from start to finish. The team at HBM provided detailed survey reports that gave us complete confidence in our land development plans.',
    image: 'https://images.unsplash.com/photo-1713557112617-e12d67bddc3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBlbmdpbmVlcmluZyUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3NzM2ODU5MDd8MA&ixlib=rb-4.1.0&q=85'
  }
];

export const surveyTypes = [
  'Site Supervision',
  'Topographical Survey',
  'Construction Layout Survey',
  'Aerial LiDAR Survey',
  'Engineering Survey',
  'Underground Utility Detection',
  '3D Scanning'
];
